// Generated with util/create-slice.js
import { reducer } from './school-information.reducer';
import * as effects from './school-information.effects';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { sRSFeatureEntityAdapters } from '@the-mcorp/elevenfiftynine-srs-lib';

export { reducer, effects };

const schoolInformationSaveBatchMessageSelector = createSelector(
	[(state: RootState) => state.schoolInformationSaveBatch],
	(stateSlice) => {
		return stateSlice.statusMessage;
	}
);

/**
 * Export all selectors
 */
export const schoolInformationSaveBatchSelectors = {
	dataMessage: {
		schoolInformationSaveBatchMessageSelector,
	},
	data: {},
};
